// ABP status copy shared by the OE tab upload section and the ABP Dashboard
// uploads list, so the dashboard util does not import from a component.
export const ABP5_GENERATION_FAILED_MESSAGE = 'Generation failed'
export const CONTRIBUTION_PROCESSING_FAILED_MESSAGE = 'Processing failed'
// EMS-11022 compact error copy (case #1 failed validation, case #3
// contribution model generated with errors).
export const INVALID_FILE_MESSAGE = 'This file is invalid.'
export const CONTRIBUTION_GENERATED_WITH_ERRORS_MESSAGE =
  'Contribution model generated with errors.'
